<template>
  <el-header class="y-fl-header h_header" v-bind:style="{ background: headerBackgroundColor }">
    <el-row>
      <el-col>
        <div
          class="y-fl-title-text h_header_text"
          v-bind:style="{ color: headerTextColor }"
        >{{ title }}</div>
      </el-col>
    </el-row>
  </el-header>
</template>

<script>
import { custToolHelper } from '../../mixins/custToolHelper'
// Props Object Model  //
/*   headerConfig: {
      headerText: 'Sub-brand Management',
    } */
export default {
  data() {
    return {
      config: this.headerConfig,
      title: this.headerConfig.headerText
    }
  },
  props: {
    headerConfig: Object
  },
  created() {},
  mixins: [custToolHelper],
  computed: {
    headerBackgroundColor() {
      return this.getItemDefaultValue(
        'fl-finapp',
        'header_background_color',
        'header'
      )
    },
    headerTextColor() {
      return this.getItemDefaultValue(
        'fl-finapp',
        'header_text_color',
        'header'
      )
    }
  },
  methods: {}
}
</script>

<style>
.y-fl-header {
  height: 50px !important;
  line-height: 50px;
  text-align: center;
  position: relative;
}
.y-fl-title-text {
  display: inline-block;
}
</style>
